"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

class Timer {
  constructor(callback, delay) {
    this.callback = callback;
    this.delay = delay;
    this.start();
  }

  start() {
    this.remaining = this.delay;
    this.resume();
  }

  pause() {
    window.clearTimeout(this.id);
    this.remaining -= Date.now() - this.startedAt;
  }

  resume() {
    this.startedAt = Date.now();
    window.clearTimeout(this.id);
    this.id = window.setTimeout(this.callback, this.remaining);
  }

  stop() {
    window.clearTimeout(this.id);
    this.remaining = 0;
  }

  reset() {
    window.clearTimeout(this.id);
    this.start();
  }

  extend(delay) {
    this.delay = this.remaining + delay;
    this.start();
  }

}

exports.default = Timer;